import { toast } from "sonner";
import { Ppp } from "@/types";
import { useDeletePpp } from "@/hooks/usePppMutations";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";

interface PppDeleteDialogProps {
  ppp: Ppp | null;
  onOpenChange: (open: boolean) => void;
}

export function PppDeleteDialog({ ppp, onOpenChange }: PppDeleteDialogProps) {
  const del = useDeletePpp();

  const confirm = () => {
    if (!ppp) return;
    del.mutate(ppp.pid, {
      onSuccess: () => { toast.success("PPP deleted"); onOpenChange(false); },
      onError: () => toast.error("Could not delete PPP"),
    });
  };

  return (
    <AlertDialog open={!!ppp} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete PPP</AlertDialogTitle>
          <AlertDialogDescription>
            "{ppp?.name}" will be deleted. {ppp?.deliverableCount ?? 0} committed deliverable(s) are linked to it; any left with no other PPP will move to Candidates.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={confirm}
            disabled={del.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {del.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
